import {
  LIST_MASTER_REQUEST,
  LIST_MASTER_SUCCESS,
  LIST_MASTER_FAIL,
  PATCH_MASTER_REQUEST,
  PATCH_MASTER_SUCCESS,
  PATCH_MASTER_FAIL,
  DETAIL_MASTER_REQUEST,
  DETAIL_MASTER_SUCCESS,
  DETAIL_MASTER_FAIL
} from '../../constants/master-crud'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingPatch: false,
  data: [],
  detail: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const crud = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MASTER_REQUEST:
      return { ...state, loading: true }
    case LIST_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        pageable: action.pageable
      }
    case LIST_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        data: action.dummy,
        error: action.payload
      }
    case PATCH_MASTER_REQUEST:
      return { ...state, loadingPatch: true }
    case PATCH_MASTER_SUCCESS:
      return {
        ...state,
        loadingPatch: false,
        detail: action.payload,
        pageable: action.pageable
      }
    case PATCH_MASTER_FAIL:
      return {
        ...state,
        loadingPatch: false,
        error: action.payload
      }
    case DETAIL_MASTER_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        error: null,
        detail: {}
      }
    case DETAIL_MASTER_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detail: action.payload,
        error: null
      }
    case DETAIL_MASTER_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default crud
